import { render } from "./DocumentPdfPreviewCard.vue?vue&type=template&id=ce69a1bc&scoped=true"
import script from "./DocumentPdfPreviewCard.vue?vue&type=script&lang=js"
export * from "./DocumentPdfPreviewCard.vue?vue&type=script&lang=js"

import "./DocumentPdfPreviewCard.vue?vue&type=style&index=0&id=ce69a1bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce69a1bc"]])

export default __exports__